export default __webpack_public_path__ + "static/media/LoginBackground.bfbf66e9.png";